const appConfig = {
    apiPrefix:  process.env.REACT_APP_API,
    authenticatedEntryPath: '/dashboard/default',
    onBoardingEntryPath: '/onboarding/survey/welcome',
    unAuthenticatedEntryPath: '/sign-in',
    appHome: '/',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
